export default __webpack_public_path__ + "static/2276-fa0dbcea31d227a239ca9a498d7d9427.gif";